export default {
  accounts: "Accounts",
  account_list: "Account List",
  account_settings: "Account Settings",
  account_profile: "Account Profile",
  account_creation: "Account Creation",
  active_bet_list: "Active Bet List",
  access_log: "Access Log",
  account_log: "Account Log",
  account_overview: "Account Overview",
  account_ip_list: "Account IP List",
  account_pt_update_list: "Account PT Update List",

  bet_limit_settings: "Bet Limit Settings",
  bet_limit_log: "Bet Limit Log",

  cancelled_bet_list: "Cancelled Bet List",
  commission_settings: "Commission Settings",
  commission_log: "Commission Log",
  currency_list: "Currency List",

  daily_winlose: "Daily Winlose ",
  daily_winlose_base: "Winlose (MYR)",
  daily_winlose_detail: "Winlose Detail",
  daily_winlose_base_detail: "Winlose Detail (MYR)",
  daily_winlose_match: "Winlose By Match",
  daily_winlose_match_detail: "Winlose By Match Detail",
  daily_statement: "Daily Statement",
  first_time_page: "First Time login",
  daily_winlose_tournament: "OP Tournament",
  daily_winlose_tournament_detail: "OP Tournament Detail",

  game_result: "Game Result",
  game_result_detail: "Game Result Detail",

  log: "Log",
  login_page: "Sportsbook Agent Site",
  login_ip_agent_log: "Login IP Agent Log",
  login_ip_member_log: "Login IP Member Log",

  new_login: "New Login",
  new_account: "New Account",
  new_account_api: "New Account (API)",

  member_log: "Member Log",

  overview: "Overview",

  platform_winlose: "Winlose By Product",
  platform_winlose_base: "Winlose By Product (MYR)",
  platform_winlose_detail: "Winlose By Product Detail",
  platform_winlose_detail_base: "Winlose By Product Detail (MYR)",
  pending_matches: "Pending Matches",
  position_taking_settings: "Position Taking Settings",
  profile_settings: "Profile Settings",
  position_taking_log: "Position Taking Log",

  reports: "Reports",

  settlement: "Transfer",
  settlement_list: "Transfer List",
  settlement_history: "Transfer History",
  security_page: "Security Authentication",
  sportsbook: "Sportsbook Agent",

  transaction_log: "Transaction Log",
  two_step_verification: "Two-Step Verification",
  tournament_jackpot: "Tournament Jackpot",
  tournament_refund: "Tournament Refund List",

  update_profile: "Update Profile",
  update_password: "Update Password",
  update_security: "Update Security",

  winning_margin: "Winning Margin",
  tournament_op_list: "Tournament Operator List",
  ticket: "Ticket",
  ticket_list: "Ticket List",

  ALL: "ALL",
  SPORTSBOOK: "SPORTSBOOK",
  LIVECASINO: "LIVE CASINO",
  SLOTS: "SLOTS",
  LOTTERY: "LOTTERY",
  agent: "Agent",
  member: "Member",
  daily_earning_1: "Earning By Provider",
  daily_earning_2: "Earning By Date",
  monthly_bank_statement: "Monthly Bank Statement",
  daily_bank_statement: "Daily Bank Statement",
  transfer_log: "Transfer Log",
  agent_login: "Agent Login",
  member_login: "Member Login",
  profile_log: "Profile Log",
  authority_log: "Authority Log",
  betlimit_log: "Bet Limit Log",
  betlimit_sports_log: "Bet Limit (Sportsbook)",
  action_log: "Action Log",
  redeposit_ticket: "Redeposit Ticket",
  transfer_history: "Transfer History",
  transfer_history: "Transfer History",
  adjustment_deposit: "Adjustment Deposit",
  adjustment_withdrawal: "Adjustment Withdrawal",
  manual_deposit: "Ticket Deposit",
  manual_withdrawal: "Ticket Withdrawal",
  pending_ticket: "Pending Ticket",
  member_tac: "Member TAC",
  member_tac_list: "Member TAC List",
  daily_metrics: "Daily Metrics"
};